/* CheckBox.tsx
   Version: 1.0.1
   Date: 2020-12-12
*/

// eslint-disable-next-line
import * as React from 'react';
import PropTypes from 'prop-types';

export interface CheckBoxProps {
    className?: string
    name: string;
    index?: number;
    rowindex?: number;
    colindex?: number;
    checked?: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckBox: React.FC<CheckBoxProps> = (props): JSX.Element => {

    CheckBox.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        index: PropTypes.number,
        rowindex: PropTypes.number,
        colindex: PropTypes.number,
        checked: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
    }

    return <span className= {props.className ?? 'basic-checkbox'}>
            <input 
                type='checkbox' 
                data-name={props.name} 
                data-index={props.index} 
                data-rowindex={props.rowindex}
                data-colindex={props.colindex}
                value={props.name} 
                onChange={props.onChange} 
                checked={props.checked} />
        </span>

}

export default CheckBox;